import { DefaultError, useQuery } from '@tanstack/react-query';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import  { IIsrc } from 'services/codesDistributor/types';

export const useGetIsrc = () => {
    const { responseHandler } = useResponseHandler();
    return useQuery<IIsrc, DefaultError>({
      queryKey: ['get-single-isrc'],
      async queryFn() {
        const response = await apiClient({
          method: 'GET',
          url: `CodesDistributor/Isrc/Generate`,
        });

        return responseHandler(response, {
          groupName: `useGetSingleIsrc`,
        });
      },
      enabled: false,
    });
  };